import {
  React,
  useRef,
  useEffect,
  memo,
  Radio,
  Slider,
  useGetLayoutImagesMutation,
  useState,
  Box,
  LoadingSpinner,
  GetCookie,
} from "../../../Libraries/Post/EditPost/Child/EditLayoutSelectionSlider/index";
var settings = {
  arrows: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 1000,
  pauseOnHover: true,
  dots: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const EditLayoutSelectionSlider = (props) => {
  const [getAllLayouts, { isLoading }] = useGetLayoutImagesMutation();
  const [Layouts, setLayouts] = useState([]);
  const slider = useRef();

  useEffect(() => {
    if (
      props?.data?.selectedLayout === "5" ||
      props?.data?.selectedLayout === "6"
    ) {
      slider.current.slickGoTo(4);
    } else if (
      props?.data?.selectedLayout === "1" ||
      props?.data?.selectedLayout === "2" ||
      props?.data?.selectedLayout === "3" ||
      props?.data?.selectedLayout === "4"
    ) {
      slider.current.slickGoTo(0);
    } else {
      slider.current.slickGoTo(0);
    }
  }, [props]);

  const handleChange = (event) => {
    props.handleChangeSelectedLayout(event.target.value);
  };

  useEffect(() => {
    const getAllLayoutsfun = async () => {
      try {
        const layoutsdata = new FormData();
        layoutsdata.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        layoutsdata.append("security_token", await GetCookie("es_token"));
        const res = await getAllLayouts(layoutsdata).unwrap();
        if (
          res.connection === "true" &&
          res.message === "Layouts available" &&
          res.status === "true"
        ) {
          setLayouts(res.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getAllLayoutsfun();
  }, [getAllLayouts]);

  return (
    <>
      {isLoading ? <LoadingSpinner /> : null}
      <Box sx={{ flexGrow: 1, mb: 3, ml: 2, mr: 1 }}>
        <b>Select Layout</b>
        <div className="border-round">
          <Slider {...settings} ref={slider}>
            {Layouts?.map((layout) => (
              <div
                className="col-12 md:col-12 lg:col-12 "
                key={layout.ser_layout_id}
              >
                <div className="surface-0 shadow-2 carddesign outerdesign">
                  <div className="flex justify-content-between p-2">
                    <div>
                      <span className="block text-500 font-medium text-black">
                        {layout.txt_layout_name}
                      </span>
                    </div>
                    <div
                      className="flex align-items-center justify-content-center border-round"
                      style={{ width: "1.5rem", height: "1.5rem" }}
                    >
                      <Radio
                        checked={
                          props.data.selectedLayout === layout.ser_layout_id
                        }
                        onChange={handleChange}
                        value={layout.ser_layout_id}
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                      />
                    </div>
                  </div>
                  <img
                    src={layout.txt_layout_link}
                    alt="layouts"
                    height="100%"
                    width="100%"
                    className="layoutimages"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </Box>
    </>
  );
};

export default memo(EditLayoutSelectionSlider);
